const gallery = {
  allDesigns: "Все дизайны",
  preview: "Предпросмотр",
  openDesign: "Открыть дизайн",
  backToGallery: "Назад в галерею",
  noDesigns: "Дизайнов пока нет",
  route: "Маршрут",
  createdAt: "Создано",
  tags: "Теги",
  landing: "Лендинг",
  website: "Сайт",
  dashboard: "Дашборд",
  component: "Компонент",
} as const;
export default gallery;
